(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gtt-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gtt-collbar]').forEach(function (bar) {
      var grid = document.querySelector('[data-gtt-grid]');
      var none = document.querySelector('[data-gtt-none]');
      var countEl = bar.querySelector('[data-gtt-count]');
      var chips = bar.querySelectorAll('.gtt-collbar__chip');
      function filter(type) {
        var shown = 0;
        grid.querySelectorAll('.gtt-collcard').forEach(function (card) {
          var match = type === 'all' || card.dataset.type === type;
          card.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (countEl) countEl.textContent = shown;
        if (none) none.hidden = shown !== 0;
      }
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          filter(chip.dataset.type);
        });
      });
      var reset = document.querySelector('[data-gtt-reset]');
      if (reset) reset.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.toggle('is-active', c.dataset.type === 'all'); });
        filter('all');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtt-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gtt-finder]').forEach(function (root) {
      var panel = root.querySelector('[data-gtt-panel]');
      var chips = root.querySelectorAll('.gtt-finder__chip');
      function apply(chip) {
        chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
        chip.classList.add('is-active'); chip.setAttribute('aria-selected', 'true');
        panel.style.setProperty('--body', chip.dataset.body);
        var shot = root.querySelector('[data-gtt-shot]');
        if (shot && chip.dataset.img) { shot.src = chip.dataset.img; }
        root.querySelector('[data-gtt-name]').textContent = chip.dataset.name;
        root.querySelector('[data-gtt-why]').textContent = chip.dataset.why;
        root.querySelector('[data-gtt-sub]').textContent = chip.dataset.sub;
        root.querySelector('[data-gtt-linkname]').textContent = chip.dataset.name;
        root.querySelector('[data-gtt-link]').setAttribute('href', '/products/' + chip.dataset.handle);
      }
      chips.forEach(function (chip) { chip.addEventListener('click', function () { apply(chip); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtt-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gtt-hdr]').forEach(function (hdr) {
      var onScroll = function () { hdr.setAttribute('data-scrolled', window.scrollY > 16 ? 'true' : 'false'); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      var toggle = hdr.querySelector('[data-gtt-search-toggle]');
      if (toggle) toggle.addEventListener('click', function () {
        var open = hdr.getAttribute('data-search') === 'true';
        hdr.setAttribute('data-search', open ? 'false' : 'true');
        if (!open) { var i = hdr.querySelector('.gtt-hdr__search-input'); if (i) setTimeout(function () { i.focus(); }, 60); }
      });
      // mobile drawer
      var burger = hdr.querySelector('[data-gtt-burger]');
      var drawer = hdr.querySelector('[data-gtt-drawer]');
      var scrim = hdr.querySelector('[data-gtt-scrim]');
      var closeBtn = hdr.querySelector('[data-gtt-close]');
      function setMenu(open) {
        hdr.setAttribute('data-menu', open ? 'true' : 'false');
        if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (drawer) drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (scrim) scrim.hidden = !open;
        document.body.classList.toggle('gtt-menu-open', open);
      }
      if (burger) burger.addEventListener('click', function () { setMenu(hdr.getAttribute('data-menu') !== 'true'); });
      if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
      if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
      if (drawer) drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtt-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.gtt-pdp').forEach(function (pdp) {
      // gallery thumbs
      var main = pdp.querySelector('#gtt-pdp-main');
      pdp.querySelectorAll('.gtt-pdp__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          if (main && t.dataset.full) main.src = t.dataset.full;
          pdp.querySelectorAll('.gtt-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
      // qty
      var qty = pdp.querySelector('[data-gtt-qty]');
      var dec = pdp.querySelector('[data-gtt-dec]'), inc = pdp.querySelector('[data-gtt-inc]');
      if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      // accordions
      pdp.querySelectorAll('[data-gtt-acc]').forEach(function (item) {
        item.querySelector('.gtt-pdp__acc-btn').addEventListener('click', function () { item.classList.toggle('is-open'); });
      });
      // sticky bar: show when the main buy button scrolls out of view
      var bar = pdp.querySelector('[data-gtt-stickybar]');
      var form = pdp.querySelector('#gtt-pdp-form');
      if (bar && form) {
        var io = new IntersectionObserver(function (es) { bar.hidden = es[0].isIntersecting; }, { rootMargin: '-80px 0px 0px 0px' });
        io.observe(form);
        var stickyAdd = pdp.querySelector('[data-gtt-stickyadd]');
        if (stickyAdd) stickyAdd.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
